export default __webpack_public_path__ + "static/appStoreBadge-ee793b49570f7899d11a18dd99a5b1cf.png";